module.exports = __webpack_public_path__ + "img/mutuali.6401bb49.svg";